// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"f433c2b4","102":"d204a23c","123":"c1007e6c","388":"5af6d119","453":"5e3d01a0","495":"567642e6","938":"acb0b473"}[chunkId] + ".chunk.js";
};